/**
 * Merges server-injected app settings (window.__APP_SETTINGS__, embedded into
 * index.html by AppSettingsInjectionMiddleware) over the client defaults.
 * Returns undefined when nothing usable was embedded, in which case the
 * caller falls back to fetching /api/app-settings.
 *
 * Merging over the defaults means a partial or stale payload shape can never
 * leave a top-level field undefined.
 */
export const mergeEmbeddedSettings = <T extends {isLoading: boolean}>(
    raw: unknown,
    defaults: T
): T | undefined => {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return undefined;
    }
    return {
        ...defaults,
        ...(raw as Partial<T>),
        isLoading: false
    };
};
